module.exports = __webpack_public_path__ + "img/whatsapp.87f5959e.svg";